import getApiClient from '@/plugins/api'
import {translations as refundStatusTranslations, colors as refundStatusColors} from '@/helpers/orderRefundStatuses'

export default {
  refundStatusLabel(status) {
    return refundStatusTranslations[status] || status
  },

  refundStatusColor(status) {
    return refundStatusColors[status] || 'secondary'
  },

  setSearchStatus: function (status) {
    this.newStatus = status
  },

  checkAccess: function () {
    const requestRole = 'ROLE_ADMIN',
      self = this

    let userRole = '';

    if (self.$store.state.user.roles) {
      userRole = self.$store.state.user.roles[0];
    }

    if (userRole === requestRole) {
      self.showUpdateStatus = true;
    }
  },

  loadOrder() {
    const self = this,
      api = getApiClient(self.$store),
      orderId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`orders/details/${orderId}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(result => {
        self.order = result.data
        self.newStatus = result.data.status
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  getGender(gender) {
    switch (gender) {
      case 'F':
        return 'Feminino'
      case 'M':
        return 'Masculino'
      case 'O':
      default:
        return 'Outros'
    }
  },

  changeOrderStatus() {
    const self = this,
      api = getApiClient(self.$store),
      orderId = self.$route.params.id

    self.$store.commit('startLoading')

    api.patch(`orders/${orderId}/change-status`,
      {
        newStatus: self.newStatus
      }, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      })
      .then(result => {
        self.order.status = result.data.orderStatusString

        if (result.status === 200) {
          self.currentAlertSuccessCounter = 10
        } else {
          self.currentAlertDangerCounter = 10
        }
      })
      .catch(error => {
        self.currentAlertDangerCounter = 10
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  saveComment() {
    const self = this,
      api = getApiClient(self.$store),
      orderId = self.$route.params.id

    self.$store.commit('startLoading')
    api.patch(`/orders/${orderId}/comment`, {
      comment: self.order.comment
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(response => {
        self.commentSuccess = true
        window.setTimeout(() => {
          self.commentSuccess = false
        }, 2000)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  getOrderAmount() {
    const self = this,
      order = self.order

    let initialValue = 0
    order.cart.accommodations?.forEach(accommodation => {
      initialValue += (accommodation.value * accommodation.quantity)
    })

    order.cart.optionals?.forEach(optional => {
      initialValue += (optional.value * optional.quantity)
    })
    let newValue = null

    if (order.cart.discount) {
      const discountedValue = initialValue - order.cart.discount
      newValue = self.formatAmount(discountedValue > 0 ? discountedValue : 0)
    }

    initialValue = self.formatAmount(initialValue)

    if (newValue) {
      initialValue = `<s>${initialValue}</s> ${newValue}`
    }

    return initialValue
  },

  formatAmount: function(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount)
  }
}
